import React, { useState, useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  setOffersAndPromotionsAnalyticsData,
  setRedeemOffersAndPromotionsAnalyticsData,
  modifyOffersData,
} from '../OffersAndPromotionsUtilities/offersAndPromotionsUtils';
import {
  getApplicableCouponsAction,
  getNonLocalisedCouponsAction,
  getLoggedinNonLocalizedCoupon,
} from '@kfc-global/react-shared/redux/Actions/CartAction';
import OffersAndPromotionsItem from '../Presentation/OffersAndPromotionsItem';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { UserOrderContext } from 'context/context';
import { goToMenuPage, filterOutBlackListedCoupons } from 'common/utilities/utils';
import { SHOW_COPY_COUPON_ACTION } from 'organisms/DealsAndOffersLanding/constants/offersAndDealsConstants';
import AuthManager from '@kfc-global/react-shared/auth/AuthManager';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
const { ANALYTICS_EVENTS } = CART_PAGE_CONSTANTS;

export const OffersAndPromotionsContainer = props => {
  const [offersContentData, setOffersContent] = useState([]);
  const appStateReducer = useSelector(data => data.appStateReducer);
  const { userStatus = {} } = appStateReducer;
  const { localized = false, loggedIn = false } = userStatus;
  const { DISPOSITION_DATA } = START_ORDER_CONSTANTS;
  const { userOrderStateDispatch } = useContext(UserOrderContext);
  const tenantData = useSelector(data => data.tenantReducer);
  const profileReducer = useSelector(data => data.profileReducer);
  const { tenantId = '' } = tenantData;
  const { applicableCoupons = [], cartData: basketData = {} } = useSelector(({ cartReducer }) => cartReducer);
  const dispatch = useDispatch();
  const openDispositionModal = () => {
    userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: true } });
  };

  useEffect(() => {
    if (applicableCoupons.length > 0) {
      const data = modifyOffersData(filterOutBlackListedCoupons(applicableCoupons));
      setOffersContent(data);
    }
  }, [applicableCoupons]);

  const getCoupons = () => {
    // RENDEV-5041: added basketData.id below if condition to check availbility of the basket before making the action.
    if (localized && basketData?.id) {
      const { customerId } = AuthManager.getInstance();
      customerId === basketData?.customer?.id &&
        dispatch(
          getApplicableCouponsAction({
            basketId: basketData?.id,
            tenantId,
          }),
        );
    } else if (loggedIn) {
      profileReducer?.customerId &&
        dispatch(
          getLoggedinNonLocalizedCoupon({
            tenantId,
            userId: profileReducer?.customerId,
          }),
        );
    } else {
      dispatch(
        getNonLocalisedCouponsAction({
          tenantId,
        }),
      );
    }
  };

  useEffect(() => {
    if (tenantId) {
      getCoupons();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localized, loggedIn, tenantId, basketData?.customer?.id, profileReducer]);

  const copyCoupon = discountCode => {
    navigator?.clipboard?.writeText(discountCode);
    userOrderStateDispatch({ type: SHOW_COPY_COUPON_ACTION });
  };

  const OffersViewAllHandler = () => {
    props.history.push({
      pathname: '/offers',
    });
    setOffersAndPromotionsAnalyticsData({
      event: 'viewAllDeals',
    });
  };

  const redeemHandler = payload => {
    setRedeemOffersAndPromotionsAnalyticsData({
      event: ANALYTICS_EVENTS.REDEEM_OFFER,
      offerTitle: payload,
    });
    discountApplyHandler(payload);
  };

  const discountApplyHandler = couponCode => {
    if (!localized) {
      openDispositionModal();
      copyCoupon(couponCode);
    } else {
      copyCoupon(couponCode);
      goToMenuPage(props.history);
    }
  };

  return (
    <div className='offers-container' data-testid='offer-container'>
      <OffersAndPromotionsItem
        data-testid='offer-items'
        contentData={offersContentData}
        onOffersViewAll={OffersViewAllHandler}
        onRedeem={redeemHandler}
        tenantId={tenantId}
        tenantData={tenantData}
      />
    </div>
  );
};

export default OffersAndPromotionsContainer;
